import { Ref } from 'react';
import { TextField } from '@material-ui/core';

const PHONE_NUMBER_LENGTH = 10;

const toDigits = (value: string): string => value.replace(/\D/g, '').slice(0, PHONE_NUMBER_LENGTH);

const toDisplayValue = (digits: string): string => digits.replace(/(\d{2})(?=\d)/g, '$1.');

export const isPhoneNumberIncomplete = (digits: string): boolean =>
  digits.length > 0 && digits.length !== PHONE_NUMBER_LENGTH;

type Props = {
  id: string;
  value: string;
  onChange: (digits: string) => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  inputRef?: Ref<HTMLInputElement>;
};

export default function PhoneNumberField({
  id,
  value,
  onChange,
  label = 'Téléphone',
  size = 'small',
  fullWidth,
  disabled,
  error,
  helperText,
  inputRef,
}: Props) {
  const isIncomplete = isPhoneNumberIncomplete(value);

  return (
    <TextField
      id={id}
      inputRef={inputRef}
      label={label}
      type="tel"
      size={size}
      variant="outlined"
      fullWidth={fullWidth}
      disabled={disabled}
      error={error ?? isIncomplete}
      helperText={helperText ?? (isIncomplete ? 'Un numéro compte dix chiffres' : undefined)}
      value={toDisplayValue(value)}
      onChange={(event) => onChange(toDigits(event.target.value))}
    />
  );
}
